import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { FormField, LabelPlacement } from '../form-field/form-field';
import { IconCheckmark } from '../icons';

export type CheckboxProps = {
  invalid?: boolean;
  label?: React.ReactNode;
  labelPlacement?: LabelPlacement;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Checkbox = forwardRef(
  (
    { label, invalid, labelPlacement = 'right', className, ...checkboxProps }: CheckboxProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const classNames = classnames(className, 'airtame-checkbox');

    return (
      <FormField
        label={label}
        invalid={invalid}
        labelPlacement={labelPlacement}
        disabled={checkboxProps.disabled}
        className={classNames}
      >
        <input
          ref={ref}
          className="airtame-checkbox__replaced"
          type="checkbox"
          {...checkboxProps}
        />
        <div className="airtame-checkbox__input">
          <IconCheckmark className="airtame-checkbox__mark" />
        </div>
      </FormField>
    );
  }
);

Checkbox.displayName = 'Checkbox';
